// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__CefW9","imageUploader":"EGiftCard_imageUploader__qAK1O"};